import { useCallback, useMemo } from 'react';
import { Platform } from 'react-native';

import { API_URL, CDN_URL } from '../config';
import { useAuth } from '../context';

export const useAuthHeaders = () => {
	const {
		state: { userToken, mediaToken },
	} = useAuth();

	const hostToken = useMemo(
		() => ({
			api: userToken,
			cdn: Platform.OS !== 'web' ? mediaToken : null, //using cookie on web
			other: null,
		}),
		[userToken, mediaToken],
	);

	const getAuthToken = useCallback(
		(url: string) => {
			const hostType = getHostType(url);

			return hostToken[hostType];
		},
		[hostToken],
	);
	const getHeaders = useCallback(
		(url: string) => {
			const authToken = getAuthToken(url);
			if (!authToken) {
				return;
			}

			return { Authorization: `Bearer ${authToken}` };
		},
		[getAuthToken],
	);

	return { getHeaders };
};

function getHostType(url: string) {
	if (getIsCdnHost(url)) {
		return 'cdn';
	}
	if (getIsApiHost(url)) {
		return 'api';
	}

	return 'other';
}

function getIsApiHost(url: string) {
	return getIsUrlMatchHost(url, API_URL);
}

function getIsCdnHost(url: string) {
	return getIsUrlMatchHost(url, CDN_URL);
}

const URL_REGEX = /^(?:\w+:\/\/)?([^/]+)([^?]*)\??(.*)$/;
function getIsUrlMatchHost(url: string, host: string) {
	const [, urlHost] = URL_REGEX.exec(url) || [];
	const [, currentHost] = URL_REGEX.exec(host) || [];

	return urlHost === currentHost;
}
